
    <router-outlet [ngStyle]="{'display':'none'}"></router-outlet>
